import { render, staticRenderFns } from "./WorkBookQuestionsClosedTopEntry.vue?vue&type=template&id=e18a6fc8&scoped=true&"
import script from "./WorkBookQuestionsClosedTopEntry.vue?vue&type=script&lang=js&"
export * from "./WorkBookQuestionsClosedTopEntry.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookQuestionsClosedTopEntry.vue?vue&type=style&index=0&id=e18a6fc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18a6fc8",
  null
  
)

export default component.exports